import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import PartnerAdminNavbar from '../components/PartnerAdmin/PartnerAdminNavbar';
import MobileNavbar from '../components/MobileNavbar';
import PartnerAdminMobileNavOverlay from '../components/PartnerAdmin/PartnerAdminMobileNavOverlay';

const PartnerAdminLayout = () => {
  const [isMobileNavOverlayOpen, setIsMobileNavOverlayOpen] = useState(false);

  const location = useLocation();

  useEffect(() => {
    setIsMobileNavOverlayOpen(false);
  }, [location.pathname]);

  return (
    <div>
      <PartnerAdminNavbar />
      <MobileNavbar onHamburgerClicked={e => setIsMobileNavOverlayOpen(true)} />

      <PartnerAdminMobileNavOverlay
        isOpen={isMobileNavOverlayOpen}
        onCloseClicked={e => setIsMobileNavOverlayOpen(false)}
      />

      <main className="flex justify-center flex-grow">
        <div className="container px-2 md:px-0 pt-[66px] pb-[20px] md:py-[20px]">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default PartnerAdminLayout;
